import { combineReducers } from 'redux';
import { createFlagsReducer } from 'flag';
import { reducer as toastrReducer } from 'react-redux-toastr';

import flags from '../flags';
import mySmeltersReducer from './mySmeltersReducer';
import groupsReducer from './groupsReducer';
import locationsReducer from './locationsReducer';
import productionFactorsReducer from './productionFactorsReducer';
import lastUploadDateReducer from './lastUploadDateReducer';
import steelPseudoGroupReducer from './steel/pseudoGroupReducer';
import steelSmelterAllMapDataReducer from './steel/smelterAllMapDataReducer';
import steelSmelterAllTimeBySmelterDataReducer from './steel/smelterAllTimeBySmelterDataReducer';
import steelSmelterDataFreeReducer from './steel/smelterDataFreeReducer';
import steelSmelterDataReducer from './steel/smelterDataReducer';
import steelSmelterCapacityReducer from './steel/smelterCapacityReducer';
import steelSmelterProductionReducer from './steel/smelterProductionReducer';
import steelSmelterProductionSubsitesReducer from './steel/smelterProductionSubsitesReducer';
import steelSmelterCO2EmissionsReducer from './steel/smelterCO2EmissionsReducer';
import steelSmelterListReducer from './steel/smelterListReducer';
import steelSmeltersStateReducer from './steel/smeltersStateReducer';
import steelSmelterRecentDataReducer from './steel/smelterRecentDataReducer';
import steelSmelterRecentUpdatesDataReducer from './steel/smelterRecentUpdatesDataReducer';
import steelSmelterRegionsReducer from './steel/smelterRegionsReducer';
import steelSmelterUpdatesDataReducer from './steel/smelterUpdatesDataReducer';
import steelSelectedSmeltersReducer from './steel/selectedSmeltersReducer';
import smelterShrinkAllTimeMapDataReducer from './smelterShrinkAllTimeMapDataReducer';
import cuSmelterDataReducer from './cu/smelterDataReducer';
import cuSmelterRecentDataReducer from './cu/smelterRecentDataReducer';
import cuAllTimeBySmelterDataReducer from './cu/allTimeBySmelterDataReducer';
import cuSmeltersStateReducer from './cu/smeltersStateReducer';
import cuSelectedSmeltersReducer from './cu/selectedSmeltersReducer';
import cuMtdProductionReducer from './cu/mtdProductionReducer';
import cuSmelterProductionReducer from './cu/smelterProductionReducer';
import cuProductionBySmelterReducer from './cu/productionBySmelterReducer';
import cuSelectedProdSmeltersReducer from './cu/selectedProdSmeltersReducer';
import cuSmelterCapacityReducer from './cu/smelterCapacityReducer';
import niSmelterDataReducer from './ni/smelterDataReducer';
import niSmelterRecentDataReducer from './ni/smelterRecentDataReducer';
import niAllTimeBySmelterDataReducer from './ni/allTimeBySmelterDataReducer';
import niSmeltersStateReducer from './ni/smeltersStateReducer';
import niSelectedSmeltersReducer from './ni/selectedSmeltersReducer';
import niMtdProductionReducer from './ni/mtdProductionReducer';
import niSmelterProductionReducer from './ni/smelterProductionReducer';
import niProductionBySmelterReducer from './ni/productionBySmelterReducer';
import niSelectedProdSmeltersReducer from './ni/selectedProdSmeltersReducer';
import niSmelterCapacityReducer from './ni/smelterCapacityReducer';
import alSmelterDataReducer from './al/smelterDataReducer';
import alSmelterRecentDataReducer from './al/smelterRecentDataReducer';
import alAllTimeBySmelterDataReducer from './al/allTimeBySmelterDataReducer';
import alSmeltersStateReducer from './al/smeltersStateReducer';
import alSelectedSmeltersReducer from './al/selectedSmeltersReducer';
import alMtdProductionReducer from './al/mtdProductionReducer';
import alSmelterProductionReducer from './al/smelterProductionReducer';
import alProductionBySmelterReducer from './al/productionBySmelterReducer';
import alSelectedProdSmeltersReducer from './al/selectedProdSmeltersReducer';
import alSmelterCapacityReducer from './al/smelterCapacityReducer';
import stockpilesDataReducer from './stockpiles/stockpilesDataReducer';
import stockpilesDataBySiteReducer from './stockpiles/stockpilesDataBySiteReducer';
import scrapSteelDataReducer from './scrapSteel/scrapSteelDataReducer';
import scrapSteelDataBySiteReducer from './scrapSteel/scrapSteelDataBySiteReducer';
import sitesReducer from './sitesReducer';
import siteTypesReducer from './siteTypesReducer';
import plaingroupsReducer from './plaingroupsReducer';

export default combineReducers({
	flags: createFlagsReducer(flags),
	mySmelters: mySmeltersReducer,
	groups: groupsReducer,
	plainGroups: plaingroupsReducer,
	locations: locationsReducer,
	productionFactors: productionFactorsReducer,
	sites: sitesReducer,
	siteTypes: siteTypesReducer,
	steelSelectedSmelters: steelSelectedSmeltersReducer,
	lastUploadDate: lastUploadDateReducer,
	steelPseudoGroups: steelPseudoGroupReducer,
	steelSmelterAllMapData: steelSmelterAllMapDataReducer,
	steelSmelterAllTimeBySmelter: steelSmelterAllTimeBySmelterDataReducer,
	steelSmelterData: steelSmelterDataReducer,
	steelSmelterCapacity: steelSmelterCapacityReducer,
	steelSmelterProduction: steelSmelterProductionReducer,
	steelSmelterProductionSubsites: steelSmelterProductionSubsitesReducer,
	steelSmelterCO2Emissions: steelSmelterCO2EmissionsReducer,
	steelSmelterDataFree: steelSmelterDataFreeReducer,
	steelSmeltersState: steelSmeltersStateReducer,
	steelSmelterList: steelSmelterListReducer,
	steelSmelterRecent: steelSmelterRecentDataReducer,
	steelSmelterRecentUpdates: steelSmelterRecentUpdatesDataReducer,
	steelSmelterRegions: steelSmelterRegionsReducer,
	steelSmelterUpdates: steelSmelterUpdatesDataReducer,
	smelterShrinkedAllTimeData: smelterShrinkAllTimeMapDataReducer,
	cuSmelterData: cuSmelterDataReducer,
	cuSmelterRecent: cuSmelterRecentDataReducer,
	cuAllTimeBySmelterData: cuAllTimeBySmelterDataReducer,
	cuSmeltersState: cuSmeltersStateReducer,
	cuSelectedSmelters: cuSelectedSmeltersReducer,
	cuMtdProduction: cuMtdProductionReducer,
	cuSmelterProduction: cuSmelterProductionReducer,
	cuProductionBySmelter: cuProductionBySmelterReducer,
	cuSelectedProdSmelters: cuSelectedProdSmeltersReducer,
	cuSmelterCapacity: cuSmelterCapacityReducer,
	niSmelterData: niSmelterDataReducer,
	niSmelterRecent: niSmelterRecentDataReducer,
	niAllTimeBySmelterData: niAllTimeBySmelterDataReducer,
	niSmeltersState: niSmeltersStateReducer,
	niSelectedSmelters: niSelectedSmeltersReducer,
	niMtdProduction: niMtdProductionReducer,
	niSmelterProduction: niSmelterProductionReducer,
	niProductionBySmelter: niProductionBySmelterReducer,
	niSelectedProdSmelters: niSelectedProdSmeltersReducer,
	niSmelterCapacity: niSmelterCapacityReducer,
	alSmelterData: alSmelterDataReducer,
	alSmelterRecent: alSmelterRecentDataReducer,
	alAllTimeBySmelterData: alAllTimeBySmelterDataReducer,
	alSmeltersState: alSmeltersStateReducer,
	alSelectedSmelters: alSelectedSmeltersReducer,
	alMtdProduction: alMtdProductionReducer,
	alSmelterProduction: alSmelterProductionReducer,
	alProductionBySmelter: alProductionBySmelterReducer,
	alSelectedProdSmelters: alSelectedProdSmeltersReducer,
	alSmelterCapacity: alSmelterCapacityReducer,
	stockpilesData: stockpilesDataReducer,
	stockpilesDataBySite: stockpilesDataBySiteReducer,
	scrapSteelData: scrapSteelDataReducer,
	scrapSteelDataBySite: scrapSteelDataBySiteReducer,
	toastr: toastrReducer
});
